import { useState, useEffect } from 'react'
import { apiFriendRespond } from '../server/ServiceCall'
import * as hub from '../hub/roomHub'
import '../css/Friend.css'

interface IncomingRequest {
  fromUserCode: number
  fromNickname: string
  requestedAt:  string
}

interface Props {
  token: string
}

/**
 * 실시간 친구 요청 알림 컴포넌트
 * RoomHub에서 'FriendRequest' 이벤트 수신 시 팝업
 */
export default function FriendRequestModal({ token }: Props) {
  const [queue,   setQueue]   = useState<IncomingRequest[]>([])
  const [toast,   setToast]   = useState<string | null>(null)

  useEffect(() => {
    function onFriendRequest(data: unknown) {
      const req = data as IncomingRequest
      setQueue(prev => {
        // 중복 방지
        if (prev.some(r => r.fromUserCode === req.fromUserCode)) return prev
        return [...prev, req]
      })
    }

    function onFriendResponse(data: unknown) {
      const res = data as { fromNickname: string; action: string; message: string }
      setToast(
        res.action === 'ACCEPT'
          ? `${res.fromNickname} 님이 친구 요청을 수락했습니다!`
          : `${res.fromNickname} 님이 친구 요청을 거부했습니다.`
      )
      setTimeout(() => setToast(null), 4000)
    }

    hub.on('FriendRequest',  onFriendRequest)
    hub.on('FriendResponse', onFriendResponse)
    return () => {
      hub.off('FriendRequest',  onFriendRequest)
      hub.off('FriendResponse', onFriendResponse)
    }
  }, [])

  async function handleRespond(req: IncomingRequest, action: 'ACCEPT' | 'REJECT') {
    setQueue(prev => prev.filter(r => r.fromUserCode !== req.fromUserCode))
    const res = await apiFriendRespond(token, req.fromUserCode, action)
    setToast(res.resultMessage)
    setTimeout(() => setToast(null), 3000)
  }

  const current = queue[0]

  return (
    <>
      {/* 친구 요청 응답 팝업 (큐의 첫 번째) */}
      {current && (
        <div className="modal-overlay" style={{ zIndex: 300 }}>
          <div className="modal-box" style={{ maxWidth: 340 }}>
            <div className="modal-header">
              <h3>친구 요청</h3>
            </div>
            <p style={{ color: 'var(--text-primary, #cdd6f4)', margin: '0 0 16px' }}>
              <strong>{current.fromNickname}</strong> 님이 친구 요청을 보냈습니다.
            </p>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button
                className="faction-btn reject"
                onClick={() => handleRespond(current, 'REJECT')}
              >거부</button>
              <button
                className="faction-btn accept"
                onClick={() => handleRespond(current, 'ACCEPT')}
              >수락</button>
            </div>
          </div>
        </div>
      )}

      {/* 결과 토스트 (우하단) */}
      {toast && (
        <div style={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          background: 'var(--bg-card, #1e1e2e)',
          border: '1px solid var(--border, #313244)',
          color: 'var(--text-primary, #cdd6f4)',
          padding: '10px 18px',
          borderRadius: 8,
          fontSize: '0.85rem',
          zIndex: 300,
          boxShadow: '0 4px 16px rgba(0,0,0,.4)'
        }}>
          {toast}
        </div>
      )}
    </>
  )
}
